import { render, staticRenderFns } from "./DemoVideo.vue?vue&type=template&id=6d1f68be&scoped=true"
import script from "./DemoVideo.vue?vue&type=script&lang=js"
export * from "./DemoVideo.vue?vue&type=script&lang=js"
import style0 from "./DemoVideo.vue?vue&type=style&index=0&id=6d1f68be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1f68be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1f68be')) {
      api.createRecord('6d1f68be', component.options)
    } else {
      api.reload('6d1f68be', component.options)
    }
    module.hot.accept("./DemoVideo.vue?vue&type=template&id=6d1f68be&scoped=true", function () {
      api.rerender('6d1f68be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/DemoVideo.vue"
export default component.exports